import React, {useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import ReactModal from 'react-modal'
import moment from 'moment'
import _cloneDeep from 'lodash/cloneDeep'

import {
  UserDocumentsAdd,
  UserDocumentsView,
  UserInfoAdd,
  UserAttorneyAdd
} from '../utilites/Forms'
import {userService} from '../../services/user-service'
import {HookForm} from '../../validation/HForm'
import {userEditScheme, userAttorneyScheme} from '../../validation/scheme/userScheme'
import userDocumentScheme from '../../validation/scheme/userDocumentScheme'
import {messages} from '../../helpers/messages'
import {BackButton} from '../common'

import './user-view.scss'
import '../../assets/styles/components/_tables.scss'
import '../../assets/styles/components/_content-card.scss'
import '../../assets/styles/components/_datacard.scss'
import '../../assets/styles/components/_modal.scss'

import EditIcon from '../../assets/icons/edit.svg'
import LockIcon from '../../assets/icons/lock.svg'
import CrossIcon from '../../assets/icons/cross.svg'
import UserViewLoader from './Loader/UserViewLoader';
import {permissionsAccess} from "../../helpers/common";
import {useSelector} from "react-redux";
import Loader from "../Users/Loader/Loader";

const UserView = ({match, setTitlePage}) => {
  const [state, setState] = useState({
    showModalUserPassword: false,
    showModalDocs: false,
    showModalPersonalInfo: false,
    showModalAttorney: false,
    loading: false,
    login: "",
    password: "",
    id: match.params.id,
    user: {},
    currentDocument: {},
    commonError: '' || null,
    errorPersonalNumber: '' || null,
  })
  const {accessFeatures, isLoadingConfiguration} = useSelector(({user}) => user);
  let user = state.user

  useEffect(() => {
    accessFeatures['title.header_section'] && setTitlePage('Пользователи');
    setState(prev => ({
      ...prev,
      loading: true
    }))
    let userId = state.id
    userService.getUser(userId).then((response) => {
      setState(prev => ({
        ...prev,
        user: response.data,
        loading: false
      }))
    })
  }, [isLoadingConfiguration])

  const handleEditUser = form => {
    const mergedUser = { ...state.user, ...form.user }
    if (form.user.attorney && form.user.attorney.attorneyEndDate === ('' || null)) {
      mergedUser.attorney = { ...mergedUser.attorney, attorneyEndDate: null };
    } else if (form.user.attorney?.attorneyEndDate) {
      mergedUser.attorney = { ...mergedUser.attorney, attorneyEndDate: moment(form.user.attorney.attorneyEndDate).format('YYYY-MM-DD') };
    } else if (state.showModalPersonalInfo || state.showModalAttorney) {
      const authority = state.currentDocument.authority?.label || user.documents[0].authority;
      mergedUser.documents = [{
        ...mergedUser.documents[0],
        authority
      }];
    }   
    setState(prev => ({
      ...prev,
      loading: true,
      commonError: null
    }))
    userService.updateUser(state.id, mergedUser)
      .then(response => {
        setState(prev => ({
          ...prev,
          user: response.data,
          loading: false
        }))

        handleCloseModalPersonalInfo()
        handleCloseModalAttorney()
        handleCloseModalDocs()
      })
      .catch(error => {
        if (error.response) {
          let errorData = error.response.data
          let commonError = messages["0"]
          let errorPersonalNumber;
          if (errorData.errorCode) {
            if (errorData.errorCode === 17003) {
              errorPersonalNumber = messages[errorData.errorCode]
            } else {
              commonError = messages[errorData.errorCode]
            }
          }
          window.scrollTo(0, 0)
          setState(prev => ({
            ...prev,
            loading: false,
            commonError: commonError,
            errorPersonalNumber: errorPersonalNumber
          }))
        }
      })
  }

  const handleError = () => {
    setState(prev => ({...prev, errorPersonalNumber: ''}))
  }

  const onDocumentSubmit = document => {
    const user = _cloneDeep(state.user)
    user.documents = [{...document, authority: document.authority.label}]
    setState(prev => ({
      ...prev,
      currentDocument: {...document, authority: document.authority.label},
      user
    }))
    handleEditUser({user})
  }

  const handleEditDocument = () => {
    let document = {...state.user.documents[0]}
    if (document.authority && !document.authority.label) document.authority = {value: 0, label: document.authority}
    if (document.startDate) {
      document.startDate = moment(document.startDate).format('YYYY-MM-DD')
    }
    if (document.endDate) {
      document.endDate = moment(document.endDate).format('YYYY-MM-DD')
    }
    setState(prev => ({
      ...prev,
      currentDocument: document
    }))
    handleOpenModalDocs()
  }

  const generatePassword = () => {
    setState(prev => ({
      ...prev,
      loading: true
    }))
    userService.generatePassword(state.id).then((response) => {
      setState(prev => ({
        ...prev,
        loading: false,
        login: response.data.username,
        password: response.data.password
      }))
      handleOpenModalUserPassword()
    })
  }

  const handleOpenModalUserPassword = () => setState(prev => ({...prev, showModalUserPassword: true}))

  const handleOpenModalDocs = () => setState(prev => ({...prev, showModalDocs: true}))

  const handleOpenModalPersonalInfo = () => setState(prev => ({...prev, showModalPersonalInfo: true, commonError: ''}))

  const handleOpenModalAttorney = () => {
    if (state.user.attorney.attorneyEndDate !== null) {
      setState(prev => ({
        ...prev,
        user: {
          ...prev.user,
          attorney: {
            ...prev.user.attorney,
            attorneyEndDate: state.user.attorney.attorneyEndDate,
          }
        }
      }))
    } else {
      setState(prev => ({
        ...prev,
        user: {
          ...prev.user,
          attorney: {
            ...prev.user.attorney,
            attorneyEndDate: '',
          }
        }
      }))
    }
    setState(prev => ({...prev, showModalAttorney: true}))
  }

  const handleCloseModalUserPassword = () => setState(prev => ({...prev, showModalUserPassword: false}))

  const handleCloseModalDocs = () => setState(prev => ({...prev, showModalDocs: false}))

  const handleCloseModalPersonalInfo = () => setState(prev => ({...prev, showModalPersonalInfo: false}))

  const handleCloseModalAttorney = () => setState(prev => ({...prev, showModalAttorney: false}))

  return (
    <main className="app-content">
      {isLoadingConfiguration ?
        (<div className="content-inner">
            <Loader pageRange={1}/>
          </div>) :
        (<>
          <div className={accessFeatures['title.header_section'] ? '' : 'content-header'}>
            <div className={accessFeatures['title.header_section'] ? 'content-header-back-without-title' : 'content-header-back'}>
              <BackButton/>
            </div>
              {!accessFeatures['title.header_section'] && <h1>Пользователи</h1>}
            </div>

            <div className="content-inner">
              <div className="content-inner-data">
                <div className="content-inner-data-container">
                  {state.loading ? <UserViewLoader/> :
                    <>
                      <fieldset>
                        <div className="content-section-title">
                          <div className="content-section-title-actionitems">
                            <h2>Данные пользователя</h2>
                            <div className="d-flex m-r-spacer m-l-spacer-2">
                              {user.active ? <span className="label label-success">Активен</span> :
                                <span className="label label-gray">Неактивен</span> }
                            </div>
                            {
                              permissionsAccess("action.employee.update.password") &&
                              <button className="action-item flex-shrink-0 m-r-spacer button-icontrigger caption"
                                      onClick={generatePassword}>
                      <span className="icon">
                        <LockIcon/>
                      </span>
                                <span>Обновить данные для входа</span>
                              </button>
                            }
                            <ReactModal
                              isOpen={state.showModalUserPassword}
                              contentLabel="Modal"
                              className="modal-container"
                              overlayClassName="modal-overlay"
                            >
                              <div className="modal-header">
                                <h2>Пароль обновлен</h2>
                                <button className="button-icontrigger modal-closetrigger"
                                        onClick={handleCloseModalUserPassword}>
                          <span className="icon">
                            <CrossIcon/>
                          </span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Логин</label>
                                  <div className="form-element-data">
                                    <div className="form-element-data-text">
                                      <p>{state.login}</p>
                                    </div>
                                  </div>
                                </div>
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Пароль</label>
                                  <div className="form-element-data">
                                    <div className="form-element-data-text">
                                      <p>{state.password}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ReactModal>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <div className="content-card">
                          <div className="content-card-title">
                            <h3>Персональные данные</h3>
                            <div className="content-card-title-actions">
                              {
                                permissionsAccess("action.employee.edit") &&
                                <button className="button-icontrigger caption noborder"
                                        onClick={handleOpenModalPersonalInfo}>
                                  <span className="icon"><EditIcon/></span>
                                  <span>Редактировать</span>
                                </button>
                              }
                              <ReactModal
                                isOpen={state.showModalPersonalInfo}
                                contentLabel="Modal"
                                className="modal-container"
                                overlayClassName="modal-overlay"
                              >
                                <HookForm onSubmit={handleEditUser}
                                          validationSchema={userEditScheme}
                                          defaultValues={{user: user}}
                                          submitOnEnterPress={true}>
                                  <div className="modal-header">
                                    <h2>Персональные данные</h2>
                                    <button className="button-icontrigger modal-closetrigger"
                                            onClick={handleCloseModalPersonalInfo}>
                              <span className="icon">
                                <CrossIcon/>
                              </span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <UserInfoAdd
                                      h="true"
                                      defaultValue={user.emplPersonalNum}
                                      error={state.errorPersonalNumber}
                                      commonError={state.commonError}
                                      onFocus={handleError}
                                    />
                                  </div>
                                  <div className="modal-footer">
                                    <button className="button">Сохранить</button>
                                    <button className="button-light" onClick={handleCloseModalPersonalInfo}>
                                      Отменить
                                    </button>
                                  </div>
                                </HookForm>
                              </ReactModal>
                            </div>
                          </div>
                          <div className="content-card-content">
                            <div className="form-row">
                              <div className="form-row-item">
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Фамилия</label>
                                  <div className="form-element-data date">
                                    <div className="form-element-data-text">
                                      <p>{user.lastName}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="form-row-item">
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Имя</label>
                                  <div className="form-element-data">
                                    <div className="form-element-data-text">
                                      <p>{user.firstName}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="form-row-item">
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Отчество</label>
                                  <div className="form-element-data">
                                    <div className="form-element-data-text">
                                      <p>{user.middleName}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="form-row-item">
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Пол</label>
                                  <div className="form-element-data">
                                    <div className="form-element-data-text">
                                      <p>{user.gender}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form-row">
                              <div className="form-row-item">
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Должность</label>
                                  <div className="form-element-data">
                                    <div className="form-element-data-text">
                                      <p>{user.position}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="form-row-item">
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Личный номер</label>
                                  <div className="form-element-data">
                                    <div className="form-element-data-text">
                                      <p>{user.emplPersonalNum}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="content-card">
                          <div className="content-card-title">
                            <h3>Доверенность</h3>
                            <div className="content-card-title-actions">
                              {
                                permissionsAccess("action.employee.edit") &&
                                <button className="button-icontrigger caption noborder"
                                        onClick={handleOpenModalAttorney}>
                                  <span className="icon"><EditIcon/></span>
                                  <span>Редактировать</span>
                                </button>
                              }
                              <ReactModal
                                isOpen={state.showModalAttorney}
                                contentLabel="Modal"
                                className="modal-container"
                                overlayClassName="modal-overlay"
                              >
                                <HookForm onSubmit={handleEditUser}
                                          validationSchema={userAttorneyScheme}
                                          defaultValues={{user: {
                                            ...user, 
                                            attorney: {
                                              ...user.attorney, 
                                              attorneyDate: moment(user.attorney?.attorneyDate).format("YYYY-MM-DD"),
                                            }
                                          }
                                        }}
                                          submitOnEnterPress={true}>
                                  <div className="modal-header">
                                    <h2>Доверенность</h2>
                                    <button className="button-icontrigger modal-closetrigger"
                                            onClick={handleCloseModalAttorney}>
                              <span className="icon">
                                <CrossIcon/>
                              </span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <UserAttorneyAdd h="true"/>
                                  </div>
                                  <div className="modal-footer">
                                    <button className="button">Сохранить</button>
                                    <button className="button-light" onClick={handleCloseModalAttorney}>
                                      Отменить
                                    </button>
                                  </div>
                                </HookForm>
                              </ReactModal>
                            </div>
                          </div>
                          <div className="content-card-content">
                            <div className="form-row">
                              <div className="form-row-item">
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Номер</label>
                                  <div className="form-element-data date">
                                    <div className="form-element-data-text">
                                      <p>{user.attorney && user.attorney.attorneyNumber}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form-row">
                              <div className="form-row-item">
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Дата</label>
                                  <div className="form-element-data">
                                    <div className="form-element-data-text">
                                      <p>{user.attorney && user.attorney.attorneyDate && moment(user.attorney.attorneyDate).format("DD.MM.yyyy")}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="form-row-item">
                                <div className="form-element">
                                  <label className="form-element-label" htmlFor="#">Срок действия</label>
                                  <div className="form-element-data">
                                    <div className="form-element-data-text">
                                      <p>{user.attorney && user.attorney.attorneyEndDate !== null
                                        ? moment(user.attorney.attorneyEndDate).format("DD.MM.yyyy")
                                        : ''
                                      }</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <div className="content-card">
                          <div className="content-card-title">
                            <h3>Документы</h3>
                            <div className="content-card-title-actions">
                              {
                                permissionsAccess("action.employee.edit") &&
                                <button className="button-icontrigger caption noborder" onClick={handleEditDocument}>
                                  <span className="icon"><EditIcon/></span>
                                  <span>Редактировать</span>
                                </button>
                              }
                              <ReactModal
                                isOpen={state.showModalDocs}
                                contentLabel="Modal"
                                className="modal-container document-modal"
                                overlayClassName="modal-overlay"
                              >
                                <HookForm
                                  onSubmit={(document) => onDocumentSubmit(document)}
                                  validationSchema={userDocumentScheme}
                                  defaultValues={state.currentDocument}
                                  submitOnEnterPress={true}>
                                  <div className="modal-header">
                                    <h2>Добавить документ</h2>
                                    <button className="button-icontrigger modal-closetrigger"
                                            onClick={handleCloseModalDocs}>
                              <span className="icon">
                                <CrossIcon/>
                              </span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <UserDocumentsAdd h="true"/>
                                  </div>
                                  <div className="modal-footer">
                                    <button className="button">Сохранить</button>
                                    <button className="button-light" onClick={handleCloseModalDocs}>
                                      Отменить
                                    </button>
                                  </div>
                                </HookForm>
                              </ReactModal>
                            </div>
                          </div>
                          {user.documents && user.documents.length > 0 &&
                            <div className="content-card-content">
                              {user.documents.map((document) =>
                                <div className="datacard-body" key={document.id}>
                                  <UserDocumentsView documentInfo={document}/>
                                </div>
                              )}
                            </div>}
                        </div>
                      </fieldset>
                    </>
                  }
                </div>
              </div>
            </div>
          </>
        )}

    </main>
  )
}

export default withRouter(UserView)
